import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import Skeleton from '@mui/material/Skeleton';
import { useSettings } from '../hooks/useSettings';

export function NotificationSettings() {
  const {
    notificationPreferences,
    loadingPreferences,
    updateNotificationPreference,
    error,
    clearError,
  } = useSettings(null);

  const handleToggle = async (
    eventType: string,
    channel: 'pushEnabled' | 'emailEnabled' | 'smsEnabled',
    currentValue: boolean
  ) => {
    const pref = notificationPreferences.find((p) => p.eventType === eventType);
    if (!pref) return;

    await updateNotificationPreference({
      eventType,
      pushEnabled: channel === 'pushEnabled' ? !currentValue : pref.pushEnabled,
      emailEnabled: channel === 'emailEnabled' ? !currentValue : pref.emailEnabled,
      smsEnabled: channel === 'smsEnabled' ? !currentValue : pref.smsEnabled,
    });
  };

  if (loadingPreferences) {
    return (
      <Box>
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} variant="rectangular" height={48} sx={{ mb: 1 }} />
        ))}
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Preferencias de Notificação
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Escolha como deseja receber notificacoes para cada tipo de evento.
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={clearError}>
          {error}
        </Alert>
      )}

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Evento</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Push</TableCell>
              <TableCell align="center">SMS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notificationPreferences.map((pref) => (
              <TableRow key={pref.eventType}>
                <TableCell>{pref.eventLabel}</TableCell>
                <TableCell align="center">
                  <Switch
                    checked={pref.emailEnabled}
                    onChange={() => handleToggle(pref.eventType, 'emailEnabled', pref.emailEnabled)}
                    size="small"
                    inputProps={{ 'aria-label': `Email para ` }}
                  />
                </TableCell>
                <TableCell align="center">
                  <Switch
                    checked={pref.pushEnabled}
                    onChange={() => handleToggle(pref.eventType, 'pushEnabled', pref.pushEnabled)}
                    size="small"
                    inputProps={{ 'aria-label': `Push para ` }}
                  />
                </TableCell>
                <TableCell align="center">
                  <Switch
                    checked={pref.smsEnabled}
                    onChange={() => handleToggle(pref.eventType, 'smsEnabled', pref.smsEnabled)}
                    size="small"
                    inputProps={{ 'aria-label': `SMS para ` }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

